import getEffectiveStatus from './getEffectiveStatus';

// Counts by new-flow status, as the new portal's status cards do
const groupStatusTotals = (data) => {
  const selfAssessments =
    data?.assignedSelfAssessments || data?.allSelfAssessments;

  if (!selfAssessments?.length) return {};

  return selfAssessments.reduce((a, selfAssessment) => {
    const status = getEffectiveStatus(selfAssessment);

    return {
      ...a,
      [status]: (a[status] || 0) + 1,
    };
  }, {});
};

export default groupStatusTotals;
